import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getPosts } from '../../utils/storage';
import mockData from '../../api/mockData';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import './index.css';

function groupByMonth(posts) {
  const map = {};
  posts.forEach(p => {
    const d = new Date(p.createdAt);
    const year = d.getFullYear();
    const month = d.getMonth() + 1;
    const key = `${year}-${String(month).padStart(2,'0')}`;
    if (!map[key]) map[key] = { year, month, label: `${year}年${month}月`, posts: [] };
    map[key].posts.push(p);
  });
  return Object.values(map).sort((a,b) => (b.year - a.year) || (b.month - a.month));
}

export default function ArchiveList() {
  const [groups, setGroups] = useState([]);
  const [collapsed, setCollapsed] = useState({});

  useEffect(() => {
    const user = (() => {
      try { return JSON.parse(localStorage.getItem('my_blog_current_user'))?.username || null } catch (e) { return null }
    })();
    if (!user) {
      setGroups([]);
      return;
    }
    const posts = getPosts().filter(p => p.author === user);
    if (posts.length === 0) {
      setGroups([]);
      return;
    }
    setGroups(groupByMonth(posts));
  }, []);

  function toggle(key) {
    setCollapsed(prev => ({...prev, [key]: !prev[key]}));
  }

  function seedDemo() {
    const user = (() => {
      try { return JSON.parse(localStorage.getItem('my_blog_current_user'))?.username || null } catch (e) { return null }
    })();
    if (!user) { alert('请先登录或注册账户以初始化示例文章（示例将作为当前用户发布）'); return; }
    if (!window.confirm('将初始化示例文章到本地存储，是否继续？')) return;
    // 将示例文章作者设置为当前用户以便用户可见
    const seeded = mockData.map(p => ({ ...p, author: user }));
    localStorage.setItem('my_blog_posts_v1', JSON.stringify(seeded));
    window.location.reload();
  }

  if (groups.length === 0) {
    return (
      <div className="archive container">
        <div className="archive-empty">
          <div className="emoji">📭</div>
          <h2>暂无文章</h2>
          <p className="empty">你还没有发布任何文章。先写一篇尝试一下，或初始化示例文章来查看归档效果。</p>
          <div className="actions">
            <button className="btn" onClick={seedDemo}>初始化示例文章</button>
            <Link to="/" style={{marginLeft:12}} className="btn secondary">返回首页</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="archive container">
      <h1 className="archive-title">文章归档</h1>
      {groups.map(g => (
        <section key={`${g.year}-${g.month}`} className="archive-group">
          <header className="archive-header">
            <h3>{g.label} <span className="count">({g.posts.length})</span></h3>
            <div className="header-actions">
              <button
                aria-expanded={!collapsed[`${g.year}-${g.month}`]}
                aria-controls={`group-${g.year}-${g.month}`}
                onClick={() => toggle(`${g.year}-${g.month}`)}
                className="btn small toggle"
              >
                {!collapsed[`${g.year}-${g.month}`] ? '收起' : '展开'}
                {!collapsed[`${g.year}-${g.month}`] ? <UpOutlined /> : <DownOutlined />}
              </button>
            </div>
          </header>

          <div id={`group-${g.year}-${g.month}`} className={`archive-body ${collapsed[`${g.year}-${g.month}`] ? 'collapsed' : ''}`}>
            <ul className="archive-list">
              {g.posts.map(p => (
                <li key={p.id} className="archive-item">
                  <div className="item-title"><Link to={`/post/${p.id}`} className="archive-link">{p.title}</Link></div>
                  <div className="item-meta"><time className="meta">{new Date(p.createdAt).toLocaleDateString()}</time></div>
                </li>
              ))}
            </ul>
          </div>
        </section>
      ))}
    </div>
  );
}
